(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["country-localization"] && !Shopify.designMode) return;
  try {
    function updateFooterCountryListHeight() {
    const header = document.querySelector('theme-header');
    const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
    document.querySelectorAll('.footer localization-form').forEach((form) => {
      const button = form.querySelector('.disclosure__button');
      if (!button) return;
      const availableHeight = Math.max(48, button.getBoundingClientRect().top - headerBottom - 24);
      const height = Math.min(330, availableHeight) + 'px';
      if (form.style.getPropertyValue('--footer-country-list-height') !== height) {
        form.style.setProperty('--footer-country-list-height', height);
      }
    });
  }
  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('.footer .disclosure__button')) {
      updateFooterCountryListHeight();
    }
  }, true);
  window.addEventListener('resize', updateFooterCountryListHeight, { passive: true });
  window.addEventListener('scroll', updateFooterCountryListHeight, { passive: true });
  } catch(e) { console.error(e); }
})();

})();
